import { render, staticRenderFns } from "./FreeSoft.vue?vue&type=template&id=2710e4a2&scoped=true"
import script from "./FreeSoft.vue?vue&type=script&lang=js"
export * from "./FreeSoft.vue?vue&type=script&lang=js"
import style0 from "./FreeSoft.vue?vue&type=style&index=0&id=2710e4a2&prod&scoped=true&lang=scss"
import style1 from "./FreeSoft.vue?vue&type=style&index=1&id=2710e4a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2710e4a2",
  null
  
)

export default component.exports